import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import {
  message,
  Input,
  Button,
  Form,
  Space,
  Tooltip,
  Card,
  Modal,
  DatePicker,
  Select,
  Drawer,
} from "antd";

import {
  DeleteOutlined,
  ExclamationCircleFilled,
  EyeOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { Trans, useTranslation } from "react-i18next";
import {
  deleteActionHistory,
  getPagingActionHistory,
  deleteManyActionHistory,
  getManagementActionHistoryPage,
  deleteIntervalActionHistory,
} from "../../helpers/helper";
import DataTable from "../../Components/Common/DataTable";
import ModalInfomation from "./Components/ModalInfomation";
import { actionGroup } from "../../helpers/common";

const { RangePicker } = DatePicker;
const { confirm } = Modal;
const { Option } = Select;
const ActionHistories = () => {
  const { t } = useTranslation();
  document.title = t("actionHistory");

  const [formSearch] = Form.useForm();
  const [listActionHistory, setListActionHistory] = useState([]);

  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [indexPage, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingDeleteRows, setLoadingDeleteRows] = useState(false);
  const [showModalInfomation, setShowModalInfomation] = useState(false);
  const [infomationAction, setInfomationAction] = useState([]);
  const [listRole, setListRole] = useState([]);
  //handle time
  const [dates, setDates] = useState([]);
  const [dateDelete, setDateDelete] = useState([]);
  const [visibleForm, setVisibleForm] = useState(false);

  const getAllData = async (_prams, indexPage) => {
    try {
      const params = _prams
        ? _prams
        : {
            pageIndex: indexPage,
            pageSize: pageSize,
            search: "",
          };
      const dataRes = await getPagingActionHistory(params);
      setTotalPage(dataRes?.totalPages);
      let data = convertDataTable(dataRes.data);

      return data.length ? data : false;
    } catch (error) {
      setTotalPage(0);
      message.error(t("requiredPermission"));
      return [];
    }
  };

  const convertDataTable = (dataArray) => {
    let data =
      dataArray.length > 0 &&
      dataArray.map((item) => {
        return {
          key: item._id,
          fullName: item.createdBy?.fullName,
          userName: item.createdBy?.username,
          roleName: item.createdBy?.role?.roleName,
          actionLabel: item.action?.actionLabel,
          actionGroup: item.action?.actionGroup,
          actionName: item.action?.actionName,
          effectedItem: item.effectedItem,
          beforeEffected: item.beforeEffected,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
    return dataArray ? data : [];
  };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      try {
        const data = await getManagementActionHistoryPage();

        setTotalPage(data.dataPage?.totalPages);
        const dataShowTable = convertDataTable(data.dataPage?.data);
        setListActionHistory(dataShowTable);

        const resListRole = data.allRoles
          ? data.allRoles?.filter((item) => item.roleName !== "SuperAdmin")
          : [];
        setListRole(resListRole);

        setLoading(false);
      } catch (error) {
        message.error(t("requiredPermission"));
        setListActionHistory([]);
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const handleRefresh = async () => {
    const _params = {
      pageIndex: 1,
      pageSize: 10,
      search: "",
    };
    const dataRes = await getAllData(_params, indexPage);
    setListActionHistory(dataRes.length > 0 ? dataRes : listActionHistory);
    setPageIndex(1);
    formSearch.resetFields();
    setDates([]);
  };

  const handleSearch = async () => {
    const dataForm = formSearch.getFieldsValue();
    if (!Object.values(dataForm).some((item) => !!item) && dates.length === 0) {
      return;
    }
    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, 1);
    setListActionHistory(dataRes.length > 0 ? dataRes : false);
    setPageIndex(1);
  };

  const onPageChange = (page, page_size) => {
    setPageIndex(page);
    setPageSize(page_size);
    onPageChangeAtSearch(page, page_size);
  };

  const onPageChangeAtSearch = async (indexPage, page_size) => {
    setLoading(true);

    const params = {
      pageIndex: indexPage,
      pageSize: page_size,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, indexPage);
    setListActionHistory(dataRes.length > 0 ? dataRes : false);
    setLoading(false);
  };

  const getFormSearch = () => {
    const dataForm = formSearch.getFieldsValue();
    return {
      userName: dataForm.userName || "",
      roleIds: dataForm.roleIds || "",
      actionGroups: dataForm.actionGroups || "",
      actionName: dataForm.actionName || "",
      createdTimeStart:
        (dates.length === 2 &&
          moment(dates[0]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
      createdTimeEnd:
        (dates.length === 2 &&
          moment(dates[1]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
    };
  };
  const handleRefreshData = async (index_page) => {
    const _params = {
      pageIndex: index_page ? index_page : indexPage,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(_params);
    setListActionHistory(dataRes);
    setPageIndex(index_page ? index_page : indexPage);
  };
  const handleRefreshDataDelete = async (countRemove) => {
    const indexPageNew =
      listActionHistory.length == countRemove
        ? indexPage === 1
          ? 1
          : indexPage - 1
        : indexPage;
    handleRefreshData(indexPageNew);
  };
  const onDelete = async (key) => {
    try {
      const dataRes = await deleteActionHistory(key);
      if (dataRes.status === 1) {
        message.success(t("deleteSuccess"));
        handleRefreshDataDelete(1);
      } else {
        message.error(t("deleteFail"));
      }
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
    }
  };

  const onDeleteMultiple = async () => {
    try {
      if (dateDelete.length === 2) {
        const timeStart =
          moment(dateDelete[0]._d).utc("+0700").format("YYYY-MM-DD HH:mm") ||
          "";
        const timeEnd =
          moment(dateDelete[1]._d).utc("+0700").format("YYYY-MM-DD HH:mm") ||
          "";

        const data = {
          gte: timeStart,
          lte: timeEnd,
        };
        const dataRes = await deleteIntervalActionHistory(data);
        message.success(
          <Trans
            i18nKey="deleteManyActionSuccess"
            values={{ count: dataRes.data.deletedCount }}
          />
        );
        setDateDelete([]);
        setVisibleForm(false);
        handleRefreshDataDelete(dataRes.data.deletedCount);
      } else {
        message.error(t("deleteFail"));
      }
    } catch (error) {
      setVisibleForm(false);
      message.error(t("permisstionDeniedAction"));
    }
  };

  const handleShowModalDelete = () => {
    setVisibleForm(true);
  };
  const onClose = () => {
    setVisibleForm(false);
  };
  const onChangeRangePickerDelete = (value) => {
    if (value?.length === 2) {
      setDateDelete(value);
    } else {
      setDateDelete([]);
    }
  };

  const onChangeRangePicker = (value) => {
    if (value?.length === 2) {
      setDates(value);
    } else {
      setDates([]);
    }
  };

  const showModalConfirmDelete = (record) => {
    confirm({
      title: t("confirmDelete"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDelete(record);
      },
      onCancel() {},
    });
  };
  const showModalConfirmDeleteMultiple = () => {
    confirm({
      title: t("confirmDeleteMany"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDeleteMultiple();
      },
      onCancel() {},
    });
  };

  const handleClodeModalInfomation = () => {
    setShowModalInfomation(false);
  };

  const handleShowModalInfomation = async (data) => {
    setInfomationAction(data);
    setShowModalInfomation(true);
  };

  const columns = [
    {
      title: t("actionUserName"),
      dataIndex: "userName",
    },
    {
      title: t("role"),
      dataIndex: "roleName",
    },
    {
      title: t("actionType"),
      render: (_, record) => {
        const dataActionGroup = actionGroup.filter(
          (item) => item.value === record.actionGroup
        );
        return dataActionGroup.length ? dataActionGroup[0].label : "";
      },
    },
    {
      title: t("actionName"),
      render: (_, record) => {
        return (
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <a
              className="button-show-infomation"
              onClick={() => handleShowModalInfomation(record)}
              style={{
                padding: "5px",
                margin: "2.5px 5px 2.5px 0px",
                backgroundColor: "#f0f5ff",
                overflow: "hidden",
                border: "1px solid #adc6ff",
              }}
            >
              {record.actionLabel}
            </a>
          </div>
        );
      },
    },
    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
    {
      title: t("action"),
      dataIndex: "",
      render: (_, record) =>
        listActionHistory.length >= 1 ? (
          <Space>
            <Tooltip title={t("delete")}>
              <Button
                type="danger"
                shape="circle"
                icon={<DeleteOutlined />}
                size="small"
                onClick={() => showModalConfirmDelete(record.key)}
              />
            </Tooltip>
          </Space>
        ) : null,
    },
  ];
  const handleDeleteSelectRows = async () => {
    confirm({
      title: (
        <Trans
          i18nKey="confirmDeleteManyAction"
          values={{ count: selectedRowKeys.length }}
        />
      ),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        OnDeleteSelectRows();
      },
      onCancel() {},
    });
  };

  const OnDeleteSelectRows = async () => {
    try {
      setLoadingDeleteRows(true);

      const dataRes = await deleteManyActionHistory({
        data: { ids: selectedRowKeys },
      });

      if (dataRes.status === 1) {
        message.success(
          <Trans
            i18nKey="deleteManyActionSuccess"
            values={{ count: dataRes.data.deletedCount }}
          />
        );
        handleRefreshDataDelete(dataRes.data.deletedCount);
      } else {
        message.error(t("deleteFail"));
      }
      setSelectedRowKeys([]);
      setLoadingDeleteRows(false);
    } catch (error) {
      setLoadingDeleteRows(false);
      message.error(t("permisstionDeniedAction"));
    }
  };
  return (
    <>
      <div className="page-content">
        <Card bordered={false}>
          <Row>
            <Col xs={12}>
              <Form form={formSearch} layout="vertical" autoComplete="off">
                <Row>
                  <Col hidden={true}>
                    <Form.Item name="id" label="Id">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col sm={3}>
                    <Form.Item
                      name="userName"
                      label={t("actionUserName") + ":"}
                    >
                      <Input
                        placeholder={t("placeHolderActionUserName")}
                        allowClear={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={3}>
                    <Form.Item name="roleIds" label={t("role") + ":"}>
                      <Select
                        placeholder={t("placeHolderSelectRole")}
                        allowClear
                        showSearch
                        mode="multiple"
                        onChange={() => handleSearch()}
                      >
                        {listRole.length > 0 &&
                          listRole.map((item) => {
                            return (
                              <Option key={item._id} value={item._id}>
                                {item.roleName}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col sm={3}>
                    <Form.Item name="actionName" label={t("actionName") + ":"}>
                      <Input
                        placeholder={t("placeHolderActionName")}
                        allowClear={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={3}>
                    <Form.Item
                      name="actionGroups"
                      label={t("actionType") + ":"}
                    >
                      <Select
                        placeholder={t("placeHolderActionType") + ":"}
                        allowClear
                        showSearch
                        mode="multiple"
                        onChange={() => handleSearch()}
                      >
                        {actionGroup.length > 0 &&
                          actionGroup.map((item) => {
                            if (
                              item.value !== "attendance" &&
                              item.value !== "other" &&
                              item.value !== "actionHistory" &&
                              item.value !== "action"
                            ) {
                              return (
                                <Option key={item.value} value={item.value}>
                                  {item.label}
                                </Option>
                              );
                            } else {
                              return <></>;
                            }
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col sm={3} className="range-picker">
                    <Form.Item label={t("actionTimePeriod")} />
                    <RangePicker
                      showTime={{ format: "HH:mm" }}
                      format="DD-MM-YYYY HH:mm"
                      value={dates}
                      placeholder={[t("startTime"), t("endTime")]}
                      style={{ width: "100%" }}
                      onChange={onChangeRangePicker}
                    />
                  </Col>

                  <Col sm={4} className="mt-4">
                    <Form.Item className="">
                      <Space>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => handleSearch()}
                        >
                          {t("search")}
                        </Button>

                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => handleRefresh()}
                        >
                          {t("reload")}
                        </Button>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => handleShowModalDelete()}
                        >
                          {t("deleteByTimePeriod")}
                        </Button>
                        <Button
                          disabled={selectedRowKeys.length == 0}
                          loading={loadingDeleteRows}
                          type="danger"
                          htmlType="button"
                          onClick={() => handleDeleteSelectRows()}
                        >
                          {t("delete")}
                        </Button>
                      </Space>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>
        <DataTable
          listData={listActionHistory}
          pageSize={pageSize}
          columns={columns}
          indexPage={indexPage}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <ModalInfomation
          showModal={showModalInfomation}
          handleClodeModal={handleClodeModalInfomation}
          infomationAction={infomationAction}
        />
        <Drawer
          title={t("deleteByTimePeriod")}
          placement={"right"}
          width={"30%"}
          onClose={onClose}
          open={visibleForm}
          bodyStyle={{
            paddingBottom: 80,
          }}
          style={{ marginTop: "70px" }}
        >
          <Form layout="vertical" autoComplete="off">
            <Row>
              <Col sm={4} hidden={true}>
                <Form.Item name="id" label="Id">
                  <Input name="id" />
                </Form.Item>
              </Col>
              <Col className="range-picker">
                <RangePicker
                  showTime={{ format: "HH:mm" }}
                  format="DD-MM-YYYY HH:mm"
                  value={dateDelete}
                  placeholder={[t("startTime"), t("endTime")]}
                  onChange={onChangeRangePickerDelete}
                />
              </Col>
            </Row>
            <Form.Item style={{ paddingTop: "10px" }}>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={showModalConfirmDeleteMultiple}
                >
                  {t("confirm")}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Drawer>
      </div>
    </>
  );
};
export default ActionHistories;
